import { render, staticRenderFns } from "./trimHandleBottomLeft.vue?vue&type=template&id=056e5684&"
import script from "./trimHandleBottomLeft.vue?vue&type=script&lang=ts&"
export * from "./trimHandleBottomLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports